import { render, staticRenderFns } from "./NbSupervisorRootView.vue?vue&type=template&id=4e16c1ed"
import script from "./NbSupervisorRootView.vue?vue&type=script&lang=js"
export * from "./NbSupervisorRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports